var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReactionAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8346 0H16.5013V2.5H19.0013V4.16667H16.5013V6.66667H14.8346V4.16667H12.3346V2.5H14.8346V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 10C0.667969 5.4 4.39297 1.66667 8.99297 1.66667C9.86706 1.66667 10.7097 1.80098 11.5013 2.05005V5H14.0013V7.5H16.9526C17.2008 8.2893 17.3346 9.12912 17.3346 10C17.3346 14.6 13.6013 18.3333 8.99297 18.3333C4.39297 18.3333 0.667969 14.6 0.667969 10ZM7.33464 7.91667C7.33464 7.225 6.7763 6.66667 6.08464 6.66667C5.39297 6.66667 4.83464 7.225 4.83464 7.91667C4.83464 8.60833 5.39297 9.16667 6.08464 9.16667C6.7763 9.16667 7.33464 8.60833 7.33464 7.91667ZM5.30952 12.7187C6.1141 14.0957 7.46509 15 9.0013 15C10.5375 15 11.8885 14.0957 12.6931 12.7187C12.98 12.2276 12.5806 11.6667 12.0118 11.6667H5.99082C5.42203 11.6667 5.02256 12.2276 5.30952 12.7187ZM10.668 7.91667C10.668 8.60833 11.2263 9.16667 11.918 9.16667C12.6096 9.16667 13.168 8.60833 13.168 7.91667C13.168 7.225 12.6096 6.66667 11.918 6.66667C11.2263 6.66667 10.668 7.225 10.668 7.91667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReactionAdd);
export default __webpack_public_path__ + "static/media/icon-reaction-add.4005f4dedd1b0004a735b2f713841c46.svg";
export { ForwardRef as ReactComponent };